/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendUserDashboardCreateDto } from '../../models/backend-user-dashboard-create-dto';
import { BackendUserDashboardResponseDto } from '../../models/backend-user-dashboard-response-dto';

export interface CreateDashboardMeDashboardsPost$Params {
  body: BackendUserDashboardCreateDto;
}

export function createDashboardMeDashboardsPost(
  http: HttpClient,
  rootUrl: string,
  params: CreateDashboardMeDashboardsPost$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserDashboardResponseDto>> {
  const rb = new RequestBuilder(rootUrl, createDashboardMeDashboardsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserDashboardResponseDto>;
    }),
  );
}

createDashboardMeDashboardsPost.PATH = '/me/dashboards';
